<div [ngClass]="'stack stack--' + size">
  <ng-content />
</div>
